import { render, staticRenderFns } from "./ReprocessamentoSemestral.vue?vue&type=template&id=2b847eda&scoped=true&"
import script from "./ReprocessamentoSemestral.vue?vue&type=script&lang=js&"
export * from "./ReprocessamentoSemestral.vue?vue&type=script&lang=js&"
import style0 from "./ReprocessamentoSemestral.vue?vue&type=style&index=0&id=2b847eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b847eda",
  null
  
)

export default component.exports